module.exports = __webpack_public_path__ + "static/media/preventivostickets-06-rojo.66807a1c.svg";